/**
 * 处理数据逻辑
 */
import { service } from "@/components/Menu";
import { DEFAULT_DATA } from "@/config";
import { resolveCardApiUrl } from "@/utils/overviewTenant";

export const handleHttp = (valueConfig: any, callback: any) => {
  const {
    url,
    params = {},
    resDataKey = "result",
    dependParams,
    resDataHandle,
    // componentName: "StatisticGroup"组件需要object类型的数据
    valueType = "string",
  } = valueConfig;

  // 多租户聚合（?tenant=all）时切到 /multiTenant/ 路径，其它场景走老路径
  const requestUrl = resolveCardApiUrl(url, params);

  if (dependParams) {
    service
      .requestCommon(dependParams.url, dependParams.params)
      .then((resDepend: any) => {
        service.requestCommon(requestUrl, params).then((res: any) => {
          if (typeof resDataHandle === "function") {
            callback(resDataHandle(res, resDepend));
          }
        });
      });
  } else {
    service.requestCommon(requestUrl, params).then((res: any) => {
      let result: any = res;
      const resDataKeys = resDataKey.split(".");
      for (const dataKey of resDataKeys) {
        result = result[dataKey] ?? {};
      }
      if (result === res) {
        result = DEFAULT_DATA;
      } else if (typeof result === "object" && valueType !== "object") {
        result = DEFAULT_DATA;
      }
      callback(result);
    });
  }
};
